export class ArtistModel {
  id: number;
  name: string;
  uri: string;
  imageUrl: string;
}
